import axios from 'axios';
import { useUserStore } from '@/stores/user';

// private
const logError = error => {
	console.log(error);
};

// private
const getToken = (oms, bday, errorHandler, router) => {
	axios.post('/token/login/', { oms, bday }).then(response => {
		const userStore = useUserStore();
		userStore.login(oms, bday, response.data.auth_token);
		router.push({ name: 'new-appointment' });
	}).catch(errorHandler);
};

// private
const getToken2 = (username, password, errorHandler, router) => {
	axios.post('/token/login/', { username, password }).then(response => {
		const userStore = useUserStore();
		userStore.login(username, password, response.data.auth_token);
		router.push({ name: 'new-appointment' });
	}).catch(errorHandler);
};

// private
const createUser = (oms, bday, errorHandler, router) => {
	axios.post('/users/', { oms, bday }).then(response => {
		if (response.status == 201) {
			getToken(oms, bday, logError, router);
		}
	}).catch(errorHandler);
};

const createUserAndGetToken = (oms, bday, errorHandler, router) => {
	getToken(oms, bday, error => {
		createUser(oms, bday, errorHandler, router);
	}, router);
};

// private
const extractData = (handler) => {
	const extractDataCore = response => handler(response.data);
	return extractDataCore;
}

const getDoctors = (handler) => {
	axios.get('/doctors/').then(extractData(handler)).catch(logError);
};

const checkVerification = (handler) => {
	axios.get('/check_verification/').then(extractData(handler)).catch(logError);
};

const createAppointment = (data, handler) => {
	axios.post('/create_appointment/', data).then(extractData(handler)).catch(logError);
};

const getAppointmentsList = (handler) => {
	axios.get('/appointments_list/').then(extractData(handler)).catch(logError);
};

const cancelAppointment = (appointmentId, handler) => {
	axios.post('/cancel_appointment/', {'appointmentId': appointmentId}).then(extractData(handler)).catch(logError);
};

export default {
	getToken2,
	createUserAndGetToken, getDoctors, checkVerification, createAppointment, getAppointmentsList, cancelAppointment,
}
